import { render, staticRenderFns } from "./GetLocationMessage.vue?vue&type=template&id=238b8c2f"
import script from "./GetLocationMessage.vue?vue&type=script&lang=js"
export * from "./GetLocationMessage.vue?vue&type=script&lang=js"
import style0 from "./GetLocationMessage.vue?vue&type=style&index=0&id=238b8c2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports